export default "__VITE_ASSET__c3a64552__"